module.exports = __webpack_public_path__ + "static/media/BB10s.d7874ae6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/BB10s.svg
// module id = 96
// module chunks = 0